import 'iframe-resizer';
iFrameResize({ log: false }, '#webcastIframe');
